import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";
import no from "./locales/no.json";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources: {
      de,
      en,
      no,
    },
    supportedLngs: ["de", "en", "no"],
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    parseMissingKeyHandler: (key) => {
      console.error(`No translation for key: "${key}" found.`);
      return key;
    },
  });

export default i18n;
